/* collection-discover.js
   Bouton « Découvrir » : réordonne aléatoirement l'intégralité de la collection.

   Liquid ne sait pas trier au hasard et ne peut exposer qu'une fenêtre contiguë
   de produits par requête. On mélange donc les NUMÉROS DE PAGE, puis les cartes
   reçues à l'intérieur de chaque lot : coût réseau identique à la pagination
   native, zéro doublon, couverture totale du catalogue.

   Aucune persistance : recharger la page restaure l'ordre normal.
*/
(function () {
  'use strict';

  var state = null;

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function range(from, to) {
    var r = [];
    for (var i = from; i <= to; i++) r.push(i);
    return r;
  }

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getSectionId() {
    var g = getGrid();
    return g ? g.dataset.id : null;
  }

  function readTotalPages() {
    var input = document.querySelector('input[data-total-pages]');
    var n = input ? parseInt(input.value, 10) : NaN;
    return (Number.isFinite(n) && n > 0) ? n : 1;
  }

  function setLoading(on) {
    var c = document.querySelector('#ProductGridContainer .collection');
    if (c) c.classList.toggle('loading', on);
  }

  function buildUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('sort_by'); // cohérent avec la réinitialisation du tri
    url.searchParams.set('section_id', getSectionId());
    url.searchParams.set('page', String(page));
    return url.toString();
  }

  // Repositionne le select sans déclencher son événement "change",
  // sinon facets.js rechargerait toute la grille.
  function resetSort() {
    var select = document.getElementById('SortBy');
    if (!select) return;
    var def = select.getAttribute('data-default-sort');
    if (def) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === def) { select.selectedIndex = i; return; }
      }
    }
    select.selectedIndex = 0;
  }

  // Neutralise le défilement infini natif et renvoie ce dont on a besoin
  // pour le remplacer.
  function detachNative(grid) {
    var totalPages = readTotalPages(); // à lire AVANT de retirer le bloc

    var spinner = document.querySelector('.js-infinite-scroll');
    var spinnerHTML = spinner ? spinner.innerHTML : '';

    if (typeof SF_observer !== 'undefined' && SF_observer) {
      try { SF_observer.disconnect(); } catch (e) {}
    }
    if (spinner) spinner.remove();

    var data = document.querySelector('.infinite-scroll__data');
    if (data) data.remove();

    // Coupe la cible jQuery de load-more.js : une requête native encore en vol
    // ne pourra plus rien injecter, son $('.load-more-grid') sera vide.
    grid.classList.remove('load-more-grid');

    return { totalPages: totalPages, spinnerHTML: spinnerHTML };
  }

  function createSentinel(grid, innerHTML) {
    var s = document.createElement('span');
    s.className = 'infinite-scroll__loading js-discover-sentinel';
    s.innerHTML = innerHTML || '';
    grid.insertAdjacentElement('afterend', s);
    return s;
  }

  // Les blocs promo sont éditoriaux : on mémorise leur position pour les
  // réinsérer au même endroit après le mélange.
  function capturePromos(grid) {
    var promos = [];
    for (var i = 0; i < grid.children.length; i++) {
      var li = grid.children[i];
      if (li.classList.contains('collection-product-promo-img') ||
          li.classList.contains('collection-product-promo-text')) {
        promos.push({ index: i, node: li });
      }
    }
    return promos;
  }

  function restorePromos(grid, promos) {
    promos.forEach(function (p) {
      grid.insertBefore(p.node, grid.children[p.index] || null);
    });
  }

  // Réactive les composants du thème sur les cartes fraîchement injectées.
  function hydrate(cards) {
    if (typeof colorSwatches === 'function') {
      try { colorSwatches(); } catch (e) {}
    }
    if (typeof Swiper !== 'function') return;

    cards.forEach(function (li) {
      var sliders = li.querySelectorAll('.product-card-js');
      for (var i = 0; i < sliders.length; i++) {
        if (sliders[i].classList.contains('swiper-initialized')) continue;
        try {
          new Swiper(sliders[i], {
            pagination: { el: '.product-pagination .swiper-pagination', clickable: true },
            navigation: {
              nextEl: '.product-button-group .swiper-button-next',
              prevEl: '.product-button-group .swiper-button-prev'
            },
            allowTouchMove: true
          });
        } catch (e) {}
      }
    });
  }

  // Récupère une page via la Section Rendering API et mélange ses cartes.
  function fetchCards(page) {
    return fetch(buildUrl(page), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html')
                                 .getElementById('product-grid');
        var cards = [];
        if (src) {
          for (var i = 0; i < src.children.length; i++) {
            if (src.children[i].classList.contains('collection-product-card')) {
              cards.push(document.importNode(src.children[i], true));
            }
          }
        }
        return shuffle(cards);
      });
  }

  function inject(cards, isFirst) {
    var grid = state.grid;
    if (!document.contains(grid)) return; // facets.js a re-rendu entre-temps

    var frag = document.createDocumentFragment();
    cards.forEach(function (li) { frag.appendChild(li); });

    if (isFirst) {
      var promos = capturePromos(grid);
      promos.forEach(function (p) { p.node.remove(); });
      grid.innerHTML = '';
      grid.appendChild(frag);
      restorePromos(grid, promos);
    } else {
      grid.appendChild(frag);
    }
    hydrate(cards);
  }

  // Lance en arrière-plan la requête du lot suivant et mémorise sa promesse.
  function prefetch() {
    if (!state || state.pending) return;
    if (state.cursor >= state.pages.length) return;
    var page = state.pages[state.cursor++];
    state.pending = fetchCards(page).catch(function (e) {
      console.error('[discover] échec du chargement de la page', page, e);
      return [];
    });
  }

  // Consomme le lot préchargé (ou attend son arrivée) puis l'injecte.
  // Seul `cursor >= pages.length` fait autorité pour déclarer la fin :
  // `pending` est transitoirement nul entre deux lots.
  function loadBatch(isFirst) {
    if (!state || state.busy) return Promise.resolve(false);

    if (!state.pending) {
      if (state.cursor >= state.pages.length) {
        if (state.sentinel) state.sentinel.remove();
        return Promise.resolve(false);
      }
      prefetch(); // état transitoire : on relance, l'observer réessaiera
      return Promise.resolve(false);
    }

    state.busy = true;
    if (state.sentinel) state.sentinel.classList.add('loading');

    var ready = state.pending;
    state.pending = null;

    return ready
      .then(function (cards) {
        inject(cards, isFirst);
        return true;
      })
      .catch(function (e) {
        console.error('[discover] injection impossible', e);
        return false;
      })
      .then(function (ok) {
        if (!state) return ok;
        state.busy = false;
        if (state.sentinel) state.sentinel.classList.remove('loading');
        prefetch(); // on enchaîne aussitôt sur le lot d'après
        if (!state.pending && state.cursor >= state.pages.length && state.sentinel) {
          state.sentinel.remove();
        }
        return ok;
      });
  }

  function armSentinel() {
    if (!state) return;
    if (state.observer) { state.observer.disconnect(); state.observer = null; }
    if (!state.sentinel || !document.contains(state.sentinel)) return;

    if (!state.pending) {
      if (state.cursor >= state.pages.length) { state.sentinel.remove(); return; }
      prefetch();
    }

    state.observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        loadBatch(false).then(armSentinel);
      });
    }, { rootMargin: '800px' });

    state.observer.observe(state.sentinel);
  }

  function start(btn) {
    var grid = getGrid();
    if (!grid || !getSectionId()) return;
    if (state && state.busy) return;

    // Grille neuve = 1er clic, ou facets.js a re-rendu (donc on est sorti du mode).
    var fresh = !state || state.grid !== grid;
    var totalPages, spinnerHTML;

    if (fresh) {
      if (state && state.observer) state.observer.disconnect();
      var native = detachNative(grid);
      totalPages = native.totalPages;
      spinnerHTML = native.spinnerHTML;
    } else {
      // Re-clic : le bloc natif a déjà disparu, on réutilise le total mémorisé.
      totalPages = state.pages.length;
      spinnerHTML = state.spinnerHTML;
      if (state.observer) state.observer.disconnect();
      if (state.sentinel) state.sentinel.remove();
    }

    resetSort();
    setLoading(true);
    btn.classList.add('loading');

    state = {
      grid: grid,
      pages: shuffle(range(1, totalPages)),
      cursor: 0,
      sentinel: createSentinel(grid, spinnerHTML),
      observer: null,
      busy: false,
      pending: null,
      spinnerHTML: spinnerHTML
    };

    prefetch();

    loadBatch(true).then(function () {
      setLoading(false);
      btn.classList.remove('loading');
      armSentinel();
    });
  }

  // Délégation obligatoire : facets.js re-rend .facets-container à chaque
  // filtrage, ce qui détruirait un écouteur attaché directement au bouton.
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.js-random-discover');
    if (!btn) return;
    event.preventDefault();
    start(btn);
  });
})();